import { Component, OnInit, inject } from "@angular/core";
import { BaseDataTablePageDirective } from "@app/view/shared/base-pages/base-data-table-page/base-data-table-page.directive";
import { VisitCompletionRule } from "@app/models/rest/visit-completion-rule";
import { SystemSearchMetaRestService } from "@app/services/hal/system-search-meta-rest.service";
import { VisitCompletionRuleStore } from "@app/services/store/visit-completion-rule-store";
import { MatDialog } from "@angular/material/dialog";
import { UntypedFormBuilder } from "@angular/forms";
import { Router } from "@angular/router";
import { ServiceErrorHandlerService } from "@app/view/shared/service-error-handler.service";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { Store as NgrxStore } from "@ngrx/store";
import { Store } from "@bryntum/core-thin";
import { MatchRule } from "@app/models/enums/match-rule";
import { MatchAction } from "@app/models/enums/match-action";
import { AutoBookProfileStore } from "@app/services/store/auto-book-profile-store";
import { TicketCompletionCodeStore } from "@app/services/store/ticket-completion-code-store";
import { MatToolbar } from "@angular/material/toolbar";
import { MatButton } from "@angular/material/button";
import { GridComponent } from "../../../shared/base-pages/base-data-table-page/grid.component";
import { MatPaginator } from "@angular/material/paginator";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "scheduler-autobook-visit-rules",
  templateUrl: "./autobook-visit-rules.component.html",
  styleUrls: ["./autobook-visit-rules.component.scss"],
  imports: [MatToolbar, MatButton, GridComponent, MatPaginator, TranslatePipe]
})
export class AutobookVisitRulesComponent
  extends BaseDataTablePageDirective<VisitCompletionRule>
  implements OnInit
{
  visitCompletionRuleStore: VisitCompletionRuleStore;
  protected store: NgrxStore;
  protected dialog: MatDialog;
  protected formBuilder: UntypedFormBuilder;
  protected router = inject(Router);
  serverErrorHandler: ServiceErrorHandlerService;
  protected ngxUiLoaderService: NgxUiLoaderService;
  protected autoBookProfileStore = inject(AutoBookProfileStore);
  protected ticketCompletionCodeStore = inject(TicketCompletionCodeStore);

  public autoBookProfileLocalStore = new Store({
    data: []
  });
  public ticketCompletionCodeLocalStore = new Store({
    data: []
  });

  public columns: object[] = [
    { field: "ordinal", text: "Ordinal", type: "number", flex: 1 },
    {
      field: "matchRule",
      text: "Ticket Match Rule",
      flex: 1,
      editor: { type: "dropdown", items: ["ANY", "ALL"] }
    },
    {
      text: "Ticket Completion Code",
      flex: 1,
      field: "ticketCompletionCode",
      id: "ticket-code-column",
      renderer: ({ record }) =>
        record.ticketCompletionCode
          ? record.ticketCompletionCode.code
            ? record.ticketCompletionCode.code
            : "none"
          : "none",
      editable: false,
      editor: {
        type: "dropdown",
        // items: this.visitTypes,
        store: this.ticketCompletionCodeLocalStore,
        displayField: "code",
        valueField: null
      }
    },
    {
      field: "matchAction",
      text: "Match Action",
      flex: 1,
      editor: { type: "dropdown", items: ["CreateFollowOn"] }
    },
    {
      text: "Auto Book Profile",
      flex: 1,
      field: "autoBookProfile",
      id: "auto-book-profile-column",
      renderer: ({ record }) =>
        record.autoBookProfile
          ? record.autoBookProfile.description
            ? record.autoBookProfile.description
            : "none"
          : "none",
      editable: false,
      editor: {
        type: "dropdown",
        // items: this.visitTypes,
        store: this.autoBookProfileLocalStore,
        displayField: "description",
        valueField: null
      }
    }
  ];

  public get pristine() {
    return (
      !this.gridStore.changes ||
      (this.gridStore.changes.added.length === 0 &&
        this.gridStore.changes.removed.length === 0 &&
        this.gridStore.changes.modified.length === 0)
    );
  }

  constructor() {
    const systemSearchMetaRestService = inject(SystemSearchMetaRestService);
    const visitCompletionRuleStore = inject(VisitCompletionRuleStore);
    const store = inject(NgrxStore);
    const dialog = inject(MatDialog);
    const formBuilder = inject(UntypedFormBuilder);
    const serverErrorHandler = inject(ServiceErrorHandlerService);
    const ngxUiLoaderService = inject(NgxUiLoaderService);

    super(
      systemSearchMetaRestService,
      visitCompletionRuleStore,
      store,
      dialog,
      "VisitCompletionRule",
      formBuilder,
      serverErrorHandler,
      ngxUiLoaderService
    );

    this.visitCompletionRuleStore = visitCompletionRuleStore;
    this.store = store;
    this.dialog = dialog;
    this.formBuilder = formBuilder;
    this.serverErrorHandler = serverErrorHandler;
    this.ngxUiLoaderService = ngxUiLoaderService;
  }

  ngOnInit() {
    super.ngOnInit();
    this.ticketCompletionCodeStore.loadAll().then((value) => {
      this.ticketCompletionCodeLocalStore.add(value.resources);
    });
    this.autoBookProfileStore.loadAll().then((value) => {
      this.autoBookProfileLocalStore.add(value.resources);
    });
    this.gridStore.autoCommit = false;
    this.gridStore.load({});
  }

  addRow() {
    this.gridStore.insert(0, {
      ordinal: 1,
      ticketCompletionCode: null,
      matchRule: MatchRule.ANY,
      matchAction: MatchAction.CreateFollowOn,
      autoBookProfile: null
    });
  }
}
